export default {
  author: 'Origin',
  name: 'Origin',
  cookies: {
    lang: 'origin_lang',
  },
  locale: ['fr', 'en'],
  loader: true,
  mode: 'out-in',
  prefixRoute: false,
  cms: false,

  traveling_duration: 45.00,
  glb: 'v7.glb',
  
  ENTIRE_SCENE: 0,
  BLOOM_SCENE: 1
}
